import React, { useState } from "react";
import { Form } from "semantic-ui-react";

import { firebase } from "astrid-firebase";

const createLink = firebase.functions().httpsCallable("links-create");

const ProductionAuthorContactEmail = ({ people, production, productionId }) => {
	const [sending, setSending] = useState(null);

	const peopleWithEmail = Object.entries(people).filter(([id, data]) => data.email);

	const sendInvite = async (id, person, lang) => {
		setSending(id);

		try {
			const { data } = await createLink({ type: "words", targetId: productionId });

			const url = `${window.location.protocol}//${window.location.host}/words/${productionId}?link=${data.linkId}&s&a=${lang}`;

			window.location = "mailto:" + person.email + "?subject=&body=" + encodeURIComponent(url);
		} catch (error) {
			window.alert(error.message);
		} finally {
			setSending(null);
		}
	};

	return (
		!!peopleWithEmail?.length && (
			<Form as="div">
				<p>
					<b>Skicka epost med länk till uttalslista?</b>
				</p>
				{peopleWithEmail.map(([id, person]) => {
					const lang =
						person.type === "author" && production.languageOriginal
							? production.languageOriginal
							: production.language;

					return (
						<div key={id} style={{ display: "inline-block", marginBottom: "1em" }}>
							<Form.Button
								content={`${person.firstName} ${person.lastName} (${
									person.type === "author" ? "författare" : "översättare"
								})`}
								color="teal"
								size="tiny"
								loading={sending === id}
								disabled={!!sending}
								onClick={() => sendInvite(id, person, lang)}
							/>
						</div>
					);
				})}
			</Form>
		)
	);
};

export default ProductionAuthorContactEmail;
